import { Field, FieldLabel, ListCard, ListCardRow, FieldContent } from "@athena/ui";
import { useTranslation } from "react-i18next";
import { type CourseByIdQuery } from "../../graphql/courses.generated";
import { formatDateTime } from "../../../../global/formatHelpers";

interface CourseDetailsBuilderProps {
    course: CourseByIdQuery["course"] | null;
    contentLength: number;
    numModules: number;
    author: string | undefined;
}

export function CourseDetailsBuilder({ course, contentLength, numModules, author }: CourseDetailsBuilderProps) {
    const { t } = useTranslation();

    if (!course) return;

    return (
        <ListCard title={"Details"}>
            <ListCardRow className="flex flex-col items-start">
                <Field orientation="horizontal" className="w-full">
                    <FieldContent className="w-1/4">
                        <FieldLabel className="text-text-eyebrow">{t("admin.lms.status")}</FieldLabel>
                        <FieldLabel className="text-text-eyebrow">{t("common.fields.org")}</FieldLabel>
                        <FieldLabel className="text-text-eyebrow">{t("admin.lms.content")}</FieldLabel>
                        <FieldLabel className="text-text-eyebrow">{t("admin.lms.modules")}</FieldLabel>
                        <FieldLabel className="text-text-eyebrow">{t("common.fields.createdBy")}</FieldLabel>
                        <FieldLabel className="text-text-eyebrow">{t("admin.lms.createdAt")}</FieldLabel>
                        <FieldLabel className="text-text-eyebrow">{t("admin.lms.lastUpdated")}</FieldLabel>
                    </FieldContent>
                    <FieldContent className="flex-1 items-end text-right whitespace-nowrap">
                        <FieldLabel className="font-semibold">
                            {course.status === "PUBLISHED" ? "Published" : "Draft"}
                        </FieldLabel>
                        <FieldLabel className="font-semibold">{course.organization.name}</FieldLabel>
                        <FieldLabel className="font-semibold">
                            {contentLength} {t("admin.lms.items")}
                        </FieldLabel>
                        <FieldLabel className="font-semibold">
                            {numModules} {t("admin.lms.modules")}
                        </FieldLabel>
                        <FieldLabel className="font-semibold">{author}</FieldLabel>
                        <FieldLabel className="font-semibold">{formatDateTime(course.createdAt)}</FieldLabel>
                        <FieldLabel className="font-semibold">{formatDateTime(course.updatedAt)}</FieldLabel>
                    </FieldContent>
                </Field>
            </ListCardRow>
            {/* <ListCardRow>
                {(
                    [
                        "VIDEO",
                        "TEXT",
                        "QUIZ",
                    ] as const
                ).map((type) => {
                    const count = allContent.filter((c) => c.contentType === type).length;
                    if (count === 0) return null;
                    const label =
                        type === "VIDEO"
                            ? `${count} video${count !== 1 ? "s" : ""}`
                            : type === "TEXT"
                              ? `${count} reading${count !== 1 ? "s" : ""}`
                              : `${count} quiz${count !== 1 ? "zes" : ""}`;
                    return (
                        <IconBadge key={type} icon={CONTENT_TYPE_META[type].icon} variant={type}>
                            {label}
                        </IconBadge>
                    );
                })}
            </ListCardRow> */}
        </ListCard>
    );
}
